import { IoWarningOutline } from 'react-icons/io5';
import {
  MdOutlineSentimentNeutral,
  MdOutlineSentimentSatisfied,
  MdOutlineSentimentVeryDissatisfied,
} from 'react-icons/md';

export default function IconNota({ nota, alerta = false }) {
  let classBase = 'w-6 h-6 min-w-6 relative';

  if (alerta) return <IoWarningOutline className={`${classBase} text-divider-dark`} />;
  else if (nota > 0.84)
    return <MdOutlineSentimentSatisfied className={`${classBase} text-sucess-main`} />;
  else if (nota > 0.49)
    return <MdOutlineSentimentNeutral className={`${classBase} text-warning-main`} />;
  else if (nota > -1)
    return <MdOutlineSentimentVeryDissatisfied className={`${classBase} text-error-main`} />;
  else return <MdOutlineSentimentSatisfied className={`${classBase} text-purple-medium`} />;
}
